import React from 'react';

export default function Card({ children, className = '', title, subtitle, ...props }) {
  return (
    <div
      className={`bg-white rounded-2xl shadow-soft border border-gray-200 overflow-hidden ${className}`}
      {...props}
    >
      {title && (
        <div className="bg-gradient-to-r from-primary to-secondary px-6 py-5 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-white tracking-tight">{title}</h2>
          {subtitle && (
            <p className="text-sage text-sm mt-1">{subtitle}</p>
          )}
        </div>
      )}
      <div className={title ? 'p-6' : 'p-6'}>
        {children}
      </div>
    </div>
  );
}
